import m from 'mithril';

/**
 * State-based modal manager that keeps modals in the same render tree
 * This preserves Mithril's auto-redraw functionality
 */
const ModalManagerV2 = {
    // State stored as plain object
    state: {
        modals: [] // Array of {id, title, classes, component, attributes, onCrossClose}
    },

    open: function (title, classes, component, attributes, onCrossClose) {
        const id = Date.now() + Math.random();

        ModalManagerV2.state.modals.push({
            id,
            title,
            classes: classes || [],
            component,
            attributes,
            onCrossClose
        });

        // Auto-redraw happens naturally here if called from event handler
        return id;
    },

    close: function (id) {
        const index = ModalManagerV2.state.modals.findIndex(m => m.id === id);
        if (index !== -1) {
            const modal = ModalManagerV2.state.modals[index];
            if (modal.onCrossClose) {
                modal.onCrossClose();
            }
            ModalManagerV2.state.modals.splice(index, 1);
        }
        // Auto-redraw happens naturally here
    },

    closeAll: function () {
        ModalManagerV2.state.modals.forEach(modal => {
            if (modal.onCrossClose) {
                modal.onCrossClose();
            }
        });
        ModalManagerV2.state.modals = [];
        // Auto-redraw happens naturally here
    },

    // Component to render all active modals
    view: function () {
        return ModalManagerV2.state.modals.map(modal =>
            m(ModalV2, {
                key: modal.id,
                id: modal.id,
                title: modal.title,
                classes: modal.classes,
                component: modal.component,
                attributes: modal.attributes,
                onClose: () => ModalManagerV2.close(modal.id)
            })
        );
    }
};

// Individual modal component
const ModalV2 = {
    view: function (vnode) {
        const { title, classes, component, attributes, onClose } = vnode.attrs;
        const hasNoClose = classes.includes('no-close');

        return m(".modal", { class: classes.join(' ') }, [
            m("#modal-bg", { onclick: hasNoClose ? null : onClose }),
            m("#modal-inner", [
                m(".titlebar", [
                    m(".titlebar-section", title),
                    m(".titlebar-section", [
                        !hasNoClose ? m("i.icon-x c-hand", { onclick: onClose }) : ""
                    ])
                ]),
                m("#modal-target", [
                    m(component, Object.assign({}, attributes, { onModalClose: onClose }))
                ])
            ])
        ]);
    }
};

export default ModalManagerV2;
